import Install from './Install'

export default Install
